import { User } from '../user'

export interface TokenPair {
  token: string
  refresh_token: string
}

export enum ForgotPasswordpStep {
  ForgotPasswordForm = 'ForgotPasswordForm',
  MailSent = 'MailSent',
  NewPasswordForm = 'NewPasswordForm',
  ResetSuccessful = 'ResetSuccessful',
}

export interface Tenant {
  id: string
  name: string
  slug: string
}

export interface SignInResponse {
  token: string
  refresh_token: string
  user: any
  tenants: Tenant[]
  temp_token?: string
}

export interface SelectTenantResponse extends TokenPair {}

export interface SignUpResponse extends TokenPair {
  data: User
}

export interface ForgotPasswordResponse {
  token: string
}

export interface ResetPasswordResponse {
  message: string
}

export interface SignInPayload {
  email: string
  password: string
}

export interface SelectTenantPayload {
  tenant_id: string
  temp_token: string
}

export interface SignUpPayload {
  name: string
  email: string
  password: string
}

export interface ResetPasswordPayload {
  new_password: string
  token: string
}
